module.exports = __webpack_public_path__ + "static/media/iconClose.1d78eff4.svg";